// Function tabletoJSON
function tableToJson(table) {
  const data = [];
  const rows = table.querySelectorAll('tr');

  // Get header from the first row (either th or td)
  const headerCells = rows[0].querySelectorAll('th, td');
  const headers = Array.from(headerCells).map(cell => cell.innerText.trim());
  // Get contents from the 2nd row onwards
  for (let i = 1; i < rows.length; i++) {
    const cells = rows[i].querySelectorAll('td');
    // Skip empty row (if all cells are empty)
    if (Array.from(cells).every(cell => cell.innerText.trim() === '')) {
      continue;
    }

    const row = {};
    cells.forEach((cell, j) => {
      let text = cell.innerText.trim();

      // Try to parse as number, if possible
      let num = Number(text.replace(/,/g, '')); // remove commas, e.g. 1,000
      if (!isNaN(num) && text !== '') {
        row[headers[j]] = num;
      } else {
        row[headers[j]] = text;
      }
    });
    data.push(row);
  }

  return data;
}
// End of function tabletoJSON

// Function for lookbook
jQuery(function ($) {
  if ($('#page').data('template-suffix') !== 'lookbooks') return;

  var looks = [];
  $('#lookbook-tables').find('table').each(function () {
    looks = looks.concat(tableToJson(this));
  });
  $('#lookbook-tables').remove();

  Vue.component('lookbook-item', {
    template: '#lookbook-item-template',
    props: ['looksByColor', 'name'],
    data: function () {
      return {
        currentColor: Object.keys(this.looksByColor)[0],
        zooming: false,
        hasOverflow: false,   // Detects whether a slider arrow is needed
        canScrollUp: false,   // Condition of the up arrow button
        canScrollDown: false  // Condition of the down arrow button
      };
    },
    computed: {
      currentImage: function () {
        return this.looksByColor[this.currentColor].Image;
      },
    },
    mounted() {
      // Wait until Vue and the DOM are rendered
      this.$nextTick(() => {
        setTimeout(() => this.checkScroll(), 100);
      });

      // Re-detect scrolling when images load or screen size changes.
      const imgEl = this.$el.querySelector('.lookbook__img');
      if (imgEl) {
        imgEl.addEventListener('load', this.checkScroll);
      }
      window.addEventListener('resize', this.checkScroll);

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          this.checkScroll();
        });
        this.resizeObserver.observe(this.$el);
      }
    },
    beforeDestroy() {
      const imgEl = this.$el.querySelector('.lookbook__img');
      if (imgEl) {
        imgEl.removeEventListener('load', this.checkScroll);
      }
      window.removeEventListener('resize', this.checkScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    },
    methods: {
      changeColor: function (color) {
        if (this.currentColor !== color) {
          this.currentColor = color;
          this.$emit('zoom');
        }
        this.zooming = true;
        var self = this;
        setTimeout(function () {
          self.zooming = false;
        }, 350);
      },
      checkScroll: function () {
        const el = this.$refs.swatchList;
        if (!el) return;

        // 2px tolerance for browser's built-in pixel rendering error
        this.hasOverflow = el.scrollHeight > (el.clientHeight + 2);
        this.canScrollUp = el.scrollTop > 0;
        this.canScrollDown = Math.ceil(el.scrollTop + el.clientHeight) < (el.scrollHeight - 2);
      },
      scrollSwatches: function (direction) {
        const el = this.$refs.swatchList;
        if (!el) return;
        
        // Move the scroll position approximately 2 swatch sizes long.
        const scrollAmount = 120;
        el.scrollBy({ top: direction * scrollAmount, behavior: 'smooth' });
      }
    },
  });

  new Vue({
    el: '#rte',
    template: '#lookbook-template',
    data: function () {
      return {
        looks: looks,
        currentSeason: looks[0].Season,
        zoomingName: null,
        zoomedLookName: null,
        zoomedColor: null,
        isZoomingImage: false,

        // --- NEW ADDITION TO CAPITAL ARROW SLIDER ---
        visibleLimit: 15, // visibleLimit: 15, //
        observer: null, // Add variables for observers
        hasModalOverflow: false, 
        modalCanScrollUp: false,
        modalCanScrollDown: false
        
      };
    },
    watch: {
      // When changing seasons, reset the limit to 15
      currentSeason: function() {
        this.visibleLimit = 15;
        this.$nextTick(() => this.autoFitSwatchNames());
      }
    },
    computed: {
      looksBySeason: function () {
        var looksBySeason = {};
        this.looks.forEach(function (m) {
          if (!looksBySeason[m.Season]) looksBySeason[m.Season] = {};
          if (!looksBySeason[m.Season][m.Name]) looksBySeason[m.Season][m.Name] = {};
          looksBySeason[m.Season][m.Name][m.Color] = m;
        });
        return looksBySeason;
      },
      visibleLooks: function () {
        const seasonData = this.looksBySeason[this.currentSeason] || {};
        const allNames = Object.keys(seasonData);
        const visibleNames = allNames.slice(0, this.visibleLimit);
        
        // Create a new object to pass to the template
        const result = {};
        visibleNames.forEach(name => {
          result[name] = seasonData[name];
        });
        return result;
      },
      // Check if there are any hidden items left.
      hasMore: function() {
        const seasonData = this.looksBySeason[this.currentSeason] || {};
        return Object.keys(seasonData).length > this.visibleLimit;
      },
      zoomedLookImage() {
        if (
          this.zoomedLookName &&
          this.zoomedColor &&
          this.looksBySeason[this.currentSeason][this.zoomedLookName]
        ) {
          return this.looksBySeason[this.currentSeason][this.zoomedLookName][this.zoomedColor]['Image'] || '';
        }
        return '';
      }
    },
    mounted() {
      document.addEventListener('contextmenu', this.blockContextMenu);

      // Run auto-fit for the first time
      this.autoFitSwatchNames();

      // --- DISABLE THIS SECTION If Slow---    

      // 🔥 Use ResizeObserver for real-time adjustment without delay
      this.resizeObserver = new ResizeObserver(() => {
        this.autoFitSwatchNames();
      });

      // Observe each element of the container swatch
      const parents = this.$el.querySelectorAll('.lookbook__swatch');
      parents.forEach(p => this.resizeObserver.observe(p));

      // Also listen to window resize changes (fallback for zoom/viewport)
      window.addEventListener('resize', this.autoFitSwatchNames);
      
     // ------------------------------

     // IntersectionObserver Initialization
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && this.hasMore) {
          this.loadMore();
        }
      }, {
        rootMargin: '200px' // Load early before reaching the bottom
      });

      // Observe elemen trigger
      this.$nextTick(() => {
        if (this.$refs.scrollTrigger) {
          this.observer.observe(this.$refs.scrollTrigger);
        }
      });
    },
    beforeDestroy() {
      document.removeEventListener('contextmenu', this.blockContextMenu);
      // --- DISABLE THIS SECTION if it is slow ---
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.autoFitSwatchNames);
      // ------------------------------
      if (this.observer) this.observer.disconnect();
    },
    methods: {
      loadMore: function() {
        // Add logic to prevent double-triggering
        if (this.hasMore) {
          this.visibleLimit += 15;
          this.$nextTick(() => this.autoFitSwatchNames());
        }
      },
      blockContextMenu(e) {
        if (this.zoomedMotif)
          e.preventDefault();
      },
      autoFitSwatchNames() {
        if (this.zoomedMotif || this.zoomedLookName) return;

        const labels = this.$el.querySelectorAll(
          '.lookbook__swatch__name:not(.lookbook__modal .lookbook__swatch__name)'
        );

        labels.forEach(label => {
          const parent = label.parentElement;
          if (!parent) return;

          const parentWidth = Math.max(parent.offsetWidth, 43);
          const labelWidth = label.scrollWidth;

          // Reset
          label.style.transform = 'scaleX(1)';

          if (labelWidth > parentWidth) {
            const isMobile = window.innerWidth <= 768;
            const compressionFactor = isMobile ? 0.95 : 0.8;
            const scaleX = (parentWidth / labelWidth) * compressionFactor;
            label.style.transform = `scaleX(${scaleX})`;
          }
        });
      },

      // --- FUNCTION FOR MODAL SCROLL LOGIC ---
      checkModalScroll() {
        const el = this.$refs.modalSwatchList;
        if (!el) return;
        this.hasModalOverflow = el.scrollHeight > (el.clientHeight + 2);
        this.modalCanScrollUp = el.scrollTop > 0;
        this.modalCanScrollDown = Math.ceil(el.scrollTop + el.clientHeight) < (el.scrollHeight - 2);
      },
      scrollModalSwatches(direction) {
        const el = this.$refs.modalSwatchList;
        if (!el) return;
        const scrollAmount = 140; // Approximately the height of 1 swatch in capital
        el.scrollBy({ top: direction * scrollAmount, behavior: 'smooth' });
      },

      // --- UPDATE WHEN ZOOM TRIGGER IS OPENED ---
      triggerZoom(name) {
        this.zoomingName = name;
        this.zoomedLookName = name;
        const defaultColor = Object.keys(this.looksBySeason[this.currentSeason][name])[0];
        this.zoomedColor = defaultColor;

        // Trigger zoom animation when the modal is first opened
        this.isZoomingImage = true;
        setTimeout(() => {
          this.isZoomingImage = false;
        }, 250); // matches CSS transition duration

        // Run modal slider check after modal element is successfully rendered
        this.$nextTick(() => {
          setTimeout(() => this.checkModalScroll(), 150);
          setTimeout(() => this.checkModalScroll(), 600); // Fallback antisipasi gambar loading lambat
        });
      },

      changeZoomColor(color) {
        if (this.zoomedColor === color) return;

        this.isZoomingImage = true;
        this.zoomedColor = color;

        setTimeout(() => {
          this.isZoomingImage = false;
        }, 250); // matches CSS animation
      },

      closeZoom() {
        this.zoomedLookName = null;
        this.zoomedColor = null;
      }
    }
  });
});
// End of lookbook function

// Function for lookbook multi
jQuery(function($) {
  if ($('#page').data('template-suffix') !== 'lookbook-multi') {
    return;
  }
  
  var looks = [];
  //var looks = tables.tableToJSON();
  $('#lookbookmulti-tables').find('table').each(function() {
    looks = looks.concat(tableToJson(this));
  }).end().remove();

  Vue.component('lookbookmulti-item', {
    template: '#lookbookmulti-item-template',
    props   : ['looksByColor', 'name'],
    data    : function() {
      return {
        currentColor: Object.keys(this.looksByColor)[0]
      };
    },
    computed: {
      currentImage: function() {
        return this.looksByColor[this.currentColor].Image;
      }
    }
  });

  new Vue({
    el      : '#rte',
    template: '#lookbookmulti-template',
    data    : function() {

      return {
        looks        : looks,
        currentSeason: looks[0].Season
      }
    },
    computed: {
      looksBySeason: function() {

        var looksBySeason = {};
        this.looks.forEach(function(m) {

          if (!looksBySeason[m.Season]) {
            looksBySeason[m.Season] = {};
          }

          if (!looksBySeason[m.Season][m.Name]) {
            looksBySeason[m.Season][m.Name] = {};
          }

          looksBySeason[m.Season][m.Name][m.Color] = m;

        });

        return looksBySeason;

      }
    }
  });

});
// End of Function for lookbook multi

// Reusable function to initialize Motif
function initUniversalVue(tableSelector, templateId, config) {
  var motifs = [];
  $(tableSelector).find('table').each(function() {
    motifs = motifs.concat(tableToJson(this));
  });
  $(tableSelector).remove();

  new Vue({
    el: '#rte',
    template: templateId,
    data() {
      return {
        motifs: motifs,
        currentSeason: motifs.length > 0 ? motifs[0].Season : null,
        searchQuery: '',
        translations: window.motifsTranslations || {},
        
        // Zoom feature
        zoomedMotif: null,
        isZoomLoading: false,
        zoomState: 'normal', // Default state
        
        // Animasi & Swipe
        touchStartX: 0,
        touchEndX: 0,
        canvasAnimClass: 'fade-in',
        pendingAnimClass: 'fade-in',
        
        // Infinite Scroll
        visibleLimit: 6,
        observer: null
      };
    },
    watch: {
      currentSeason() {
        this.visibleLimit = 6;
        this.searchQuery = '';
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      },
      searchQuery() { this.visibleLimit = 6; },
      zoomedMotif(newVal) {
        if (newVal && config.hasZoom) {
          this.pendingAnimClass = 'fade-in'; // Default animasi saat pertama dibuka
          this.$nextTick(() => this.renderZoomToCanvas());
        }
      }
    },
    computed: {
      motifsBySeason() {
        const motifsBySeason = {};
        this.motifs.forEach(m => {
          if (!motifsBySeason[m.Season]) motifsBySeason[m.Season] = {};
          if (!motifsBySeason[m.Season][m.Pattern]) {
            motifsBySeason[m.Season][m.Pattern] = { collectionLink: '', colors: {} };
          }
          motifsBySeason[m.Season][m.Pattern].colors[m.Color] = m;
          
          // Link Logic (Different for History vs Normal)
          if (config.isHistory) {
            if ('Collection' in m && m.Collection.trim()) motifsBySeason[m.Season][m.Pattern].collectionLink = m.Collection.trim();
          } else {
           if (!motifsBySeason[m.Season][m.Pattern].collectionLink) {
              const handle = m.Pattern
                .replace(/\s*\([^)]*\)\s*$/, '') // delete " (1942)" at the end
                .trim()
                .toLowerCase()
                .replace(/\s+/g, '-');

              motifsBySeason[m.Season][m.Pattern].collectionLink = `/collections/${handle}`;
            }
          }
        });
        return motifsBySeason;
      },
      filteredMotifsBySeason() {
        if (!this.searchQuery.trim()) return this.motifsBySeason;
        const query = this.searchQuery.toLowerCase();
        const filtered = {};
        for (const season in this.motifsBySeason) {
          for (const pattern in this.motifsBySeason[season]) {
            if (pattern.toLowerCase().includes(query)) {
              if (!filtered[season]) filtered[season] = {};
              filtered[season][pattern] = this.motifsBySeason[season][pattern];
            }
          }
        }
        return filtered;
      },
      visiblePatterns() {
        const seasonData = this.filteredMotifsBySeason[this.currentSeason] || {};
        const allPatterns = Object.keys(seasonData);
        const visibleNames = allPatterns.slice(0, this.visibleLimit);
        const result = {};
        visibleNames.forEach(p => result[p] = seasonData[p]);
        return result;
      },
      hasMore() {
        const seasonData = this.filteredMotifsBySeason[this.currentSeason] || {};
        return Object.keys(seasonData).length > this.visibleLimit;
      },
      // Check whether the motif has more than 1 resolution (A2 or Full)
      hasMultipleResolutions() {
        if (!this.zoomedMotif) return false;
        return !!(this.zoomedMotif.ImageZoom || this.zoomedMotif.ImageFull);
      },
      zoomCursorClass() {
        return this.zoomedMotif ? 'cursor-pointer' : 'cursor-default';
      }
    },
    mounted() {
      if (config.hasZoom) document.addEventListener('contextmenu', this.blockContextMenu);
      window.addEventListener('keydown', this.handleKeyDown);
      
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && this.hasMore) this.loadMore();
      }, { rootMargin: '200px' });

      this.$nextTick(() => {
        if (this.$refs.scrollTrigger) this.observer.observe(this.$refs.scrollTrigger);
      });
    },
    beforeDestroy() {
      if (config.hasZoom) document.removeEventListener('contextmenu', this.blockContextMenu);
      window.removeEventListener('keydown', this.handleKeyDown);
      if (this.observer) this.observer.disconnect();
    },
    methods: {
      loadMore() {
        if (this.hasMore) this.visibleLimit += 6;
      },
      blockContextMenu(e) {
        if (this.zoomedMotif) e.preventDefault();
        },
      zoomMotif(motif) { 
        this.zoomedMotif = motif; 
        this.zoomState = 'normal'; // <--- CHANGE THIS: from 'zoom' to 'normal'
      },
      closeZoom() {
        this.zoomedMotif = null;
      },
      handleKeyDown(e) {
        if (!this.zoomedMotif) return;
        if (e.key === 'Escape') this.closeZoom();
        else if (e.key === 'ArrowRight') this.cycleZoomState('next');
        else if (e.key === 'ArrowLeft') this.cycleZoomState('prev');
      },
      handleTouchStart(e) {
        this.touchStartX = e.changedTouches[0].screenX;
      },
      handleTouchEnd(e) {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      },
      handleSwipe() {
        const swipeThreshold = 50; 
        const diff = this.touchStartX - this.touchEndX;

        if (diff > swipeThreshold) {
          this.cycleZoomState('next'); // Left swipe -> Image appears from the right
        } else if (diff < -swipeThreshold) {
          this.cycleZoomState('prev'); // Right swipe -> Image appears from the left
        }
      },
      cycleZoomState(direction) {
        let availableStates = ['normal'];
        if (this.zoomedMotif.ImageZoom) availableStates.push('zoom');
        if (this.zoomedMotif.ImageFull) availableStates.push('full');

        let currentIndex = availableStates.indexOf(this.zoomState);
        let nextIndex;
        
        if (direction === 'next') {
          nextIndex = (currentIndex + 1) % availableStates.length;
        } else {
          nextIndex = (currentIndex - 1 + availableStates.length) % availableStates.length;
        }

        // Call setZoomState by sending its target sequence
        this.setZoomState(availableStates[nextIndex]);
      },      
      setZoomState(state) {
        if (!this.zoomedMotif) return;
        if (this.zoomState === state) return; 
        
        // Buat daftar urutan dari terkecil ke terbesar
        let availableStates = ['normal'];
        if (this.zoomedMotif.ImageZoom) availableStates.push('zoom');
        if (this.zoomedMotif.ImageFull) availableStates.push('full');

        // Find out the current position of the image, and the position of the clicked image
        let currentIndex = availableStates.indexOf(this.zoomState);
        let targetIndex = availableStates.indexOf(state);

        // If clicking on a larger resolution (e.g. A4 -> A2), the animation slides from the Right.
        // If clicking on a smaller resolution (e.g. Full -> A4), the animation slides from the Left.
        if (targetIndex > currentIndex) {
          this.pendingAnimClass = 'swipe-next';
        } else {
          this.pendingAnimClass = 'swipe-prev';
        }
        
        this.zoomState = state;
        this.$nextTick(() => this.renderZoomToCanvas());
      },      
      renderZoomToCanvas() {
        const canvas = this.$refs.zoomCanvas;
        if (!canvas || !this.zoomedMotif) return;
        
        this.isZoomLoading = true;
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        let source = this.zoomedMotif.Image; 
        if (this.zoomState === 'full') {
          source = this.zoomedMotif.ImageFull || this.zoomedMotif.ImageZoom || this.zoomedMotif.Image;
        } else if (this.zoomState === 'zoom') {
          source = this.zoomedMotif.ImageZoom || this.zoomedMotif.Image;
        }
        
        img.src = source;
        img.onload = () => {
          const maxWidth = window.innerWidth * 0.9;
          const maxHeight = window.innerHeight * 0.8;
          let width = img.width; let height = img.height;
          const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
          width *= ratio; height *= ratio;
          canvas.width = width; canvas.height = height;
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);
          const fontSize = Math.max(14, Math.round(width * 0.03));
          ctx.font = `${fontSize}px sans-serif`;
          ctx.fillStyle = 'rgba(216, 208, 208, 0.4)';
          ctx.textAlign = 'right'; ctx.textBaseline = 'bottom';
          ctx.fillText('© Samanthasung', width - 12, height - 20);
          
          // Apply animation effects every time the image is finished loading
          this.canvasAnimClass = ''; 
          this.$nextTick(() => {
            void canvas.offsetWidth; // Triggers a CSS reflow so the animation can be repeated
            this.canvasAnimClass = this.pendingAnimClass;
            this.isZoomLoading = false;
          });
        };
        img.onerror = () => { this.isZoomLoading = false; };
      }
    }
  });
}

// Function for Motif
jQuery(function($) {
  const pageSuffix = $('#page').data('template-suffix');

  // Configuration for each page
  if (pageSuffix === 'motifs') {
    initUniversalVue('#motif-tables', '#motifs-template', { isHistory: false, hasZoom: true });
  } 
  else if (pageSuffix === 'motifs-history') {
    initUniversalVue('#motifshistory-tables', '#motifshistory-template', { isHistory: true, hasZoom: true });
  }
  else if (pageSuffix === 'swatch-cards') {
    // Swatch cards do NOT have zoom (hasZoom: false)
    initUniversalVue('#motifscardswatches-tables', '#motifscardswatches-template', { isHistory: false, hasZoom: false });
  }
});
// End of Function for Motif

// Fungtion for Style Guide
jQuery(function ($) {
  if ($('#page').data('template-suffix') !== 'dresses') return;

  const table = document.querySelector('#rte > table');
  const dresses = table ? tableToJson(table) : [];

  if (table) table.remove(); // Optional: clean up

  new Vue({
    el: '#rte',
    template: '#dresses-template',
    data: {
      dresses: dresses,
      currentStyle: false,
    },
    computed: {
      dressesByStyle() {
        const grouped = {};
        this.dresses.forEach(d => {
          if (!grouped[d.Style]) {
            grouped[d.Style] = {
              collectionLink: '',
              necks: {}
            };
          }

          if ('Collection' in d) {
            const collectionLink = d.Collection.trim();
            if (collectionLink) {
              grouped[d.Style].collectionLink = collectionLink;
            }
          }

          if (!grouped[d.Style].necks[d.Neck]) {
            grouped[d.Style].necks[d.Neck] = {};
          }

          grouped[d.Style].necks[d.Neck][d.Sleeve] = d;
        });
        return grouped;
      }
    },
    filters: {
      styleImg(dressesByNeck) {
        const firstNeck = Object.keys(dressesByNeck)[0];
        const firstSleeve = Object.keys(dressesByNeck[firstNeck])[0];
        return dressesByNeck[firstNeck][firstSleeve].Image;
      },
      description(dressesByNeck) {
        for (const neck in dressesByNeck) {
          for (const sleeve in dressesByNeck[neck]) {
            if (dressesByNeck[neck][sleeve].Description !== '') {
              return dressesByNeck[neck][sleeve].Description;
            }
          }
        }
        return '';
      }
    }
  });
});

// End of function for Style Guide

// Function for where to buy
jQuery(function($) {
  if ($('#page').data('template-suffix') !== 'where-to-buy') return;

  const stockists = tableToJson(document.querySelector('#rte > table'));
  document.querySelector('#rte > table').remove();

  new Vue({
    el      : '#rte',
    template: '#stockists-template',
    data    : {
      stockists     : stockists,
      countries     : ['USA', 'Italy', 'Germany', 'UK', 'Belgium', 'Austria', 'Netherlands', 'France', 'Rest of World'],
      currentCountry: 'USA',
    },
    computed: {
      stockistsByCountry: function() {
        const stockistsByCountry = {};
        this.countries.forEach(c => {
          stockistsByCountry[c] = [];
        });

        // Group stockists by country
        this.stockists.forEach(s => {
          if (this.countries.includes(s.Country)) {
            stockistsByCountry[s.Country].push(s);
          } else {
            stockistsByCountry['Rest of World'].push(s);
          }
        });

        return stockistsByCountry;
      },
      currentStockists: function() {
        return this.stockistsByCountry[this.currentCountry];
      }
    },
    filters: {
      trimUrl: function(value) {
        if (!value) return value;
        value = value.replace(/^.*:\/\//, '');
        value = value.replace(/\/$/, '');
        return value;
      }
    }
  });
});
// End of function for where to buy

//Ripple Animation
$(document).ready(function () {
  $(
    '.motifs__nav-item, \
     .motifshistory__nav-item, \
     .motifscardswatches__nav-item, \
     .stockists__nav-item, \
     .lookbook__nav-item, \
     .dresses__nav-item'
  ).on('click', function (e) {
    const $ripple = $('<span class="ripple"></span>');
    const offset = $(this).offset();
    const x = e.pageX - offset.left;
    const y = e.pageY - offset.top;
    const size = Math.max($(this).width(), $(this).height());

    $ripple.css({
      left: x - (size / 2) + 'px',
      top: y - (size / 2) + 'px',
      width: size + 'px',
      height: size + 'px'
    });

    $(this).append($ripple);

    setTimeout(() => {
      $ripple.remove();
    }, 600);
  });
});
//End of ripple animation


// Size Guide popup & Vue render
$(document).ready(function () {
  let view = null; // Use let, not const

  function openSizeGuide(e) {
    e.preventDefault();

    const $data = $('#size-guide__data');
    const rawHtml = $data.html();
    if (!rawHtml) return;

    vex.open({
      unsafeContent: rawHtml,
      afterOpen: initSizeGuide,
      beforeClose: destroySizeGuide
    });
  }

  function initSizeGuide() {
  const maxAttempts = 10;
  let attempts = 0;

  function tryInit() {
    const $data = $('#size-guide__data-container');
    if ($data.length) {
      // console.log('🟢 Vue init confirmed');
      const sketch = $data.find('img').attr('src');
      const legends = tableToJson($data.find('table').first()[0]);
      const measurements = tableToJson($data.find('table').last()[0]);

      view = new Vue({
        el: '#size-guide__data-container',
        template: '#size-guide__template',
        data: {
          sketch: sketch,
          legends: legends,
          measurements: measurements,
          unit: 'cm'
        },
        computed: {
          measurementHead: function () {
            return Object.keys(this.measurements[0] || {});
          }
        },
        methods: {
          convertUnit: function (cm) {
            const num = parseFloat(cm);
            if (isNaN(num)) return cm;
            return this.unit === 'cm' ? num.toFixed(1) : (num * 0.393701).toFixed(1);
          },
          formatValue: function (val) {
            // Use convertUnit only for numbers
            const num = parseFloat(val);
            if (isNaN(num)) return val;
            return this.convertUnit(num);
          }
        }

      });

      return; // 🛑 stop further polling
    }

    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(tryInit, 50);
   // } else {
   //   console.error('❌ Failed to find #size-guide__data-container');
    }
  }

  tryInit();
}
  function destroySizeGuide() {
    if (view) {
      view.$destroy();
      view = null;
    }
  }

  // Attach click event
  $(document).on('click', '.size-guide-trigger', openSizeGuide);

  // Optional: other popup triggers
  const popupTriggers = ['neckline','neckline-shirt', 'neckline-nonshirt', 'sleeve', 'top', 'skirt', 'top-skirt', 'style', 'measure', 'faq'];
  $.each(popupTriggers, function (i, trigger) {
    $(document).on('click', '#' + trigger + '-popup-trigger', function (e) {
      e.preventDefault();
      const contentHtml = $('#' + trigger + '-content').html();
      if (contentHtml) {
        vex.open({ unsafeContent: contentHtml });
      }
    });
  });
});

// Function search on submenu
  function filterSubmenuItems(input) {
    const query = input.value.toLowerCase();
    const list = input.closest('ul');
    const items = list.querySelectorAll('.wt-page-nav-mega__sublist__item--child');

    items.forEach(item => {
      const text = item.textContent.toLowerCase();
      item.style.display = text.includes(query) ? '' : 'none';
    });
  }

// Function shop by color
  document.addEventListener('DOMContentLoaded', function () {
    const tooltip = document.getElementById('wheel-tooltip');

    document.querySelectorAll('.has-tooltip').forEach(el => {
      el.addEventListener('mouseenter', e => {
        tooltip.textContent = el.dataset.tooltip;
        tooltip.classList.add('show');
      });

      el.addEventListener('mousemove', e => {
        tooltip.style.left = e.clientX + 'px';
        tooltip.style.top = (e.clientY - 15) + 'px';
      });

      el.addEventListener('mouseleave', () => {
        tooltip.classList.remove('show');
      });
    });

    // Accordion Toggle
    document.addEventListener('click', function(e){
      const btn = e.target.closest('.linear-acc-header');
      if(!btn) return;

      const acc = btn.closest('.linear-accordion');
      const icon = btn.querySelector('.acc-icon');
      
      // Toggle class 'open'
      const isOpen = acc.classList.toggle('open');

      // Update icons dynamically
      if (icon) {
        icon.textContent = isOpen ? '−' : '+';
      }

      /* 
        OPTIONAL: If you want a 'Single Open' system
        (open one, the other closes automatically),
        activate the code below:
      */
      /*
      if (isOpen) {
        const allAccordions = document.querySelectorAll('.linear-accordion');
        allAccordions.forEach(otherAcc => {
          if (otherAcc !== acc) {
            otherAcc.classList.remove('open');
            const otherIcon = otherAcc.querySelector('.acc-icon');
            if (otherIcon) otherIcon.textContent = '+';
          }
        });
      }
      */
    });
  });

// Function Collection list view
  document.addEventListener('DOMContentLoaded', function() {
    const allOptionSwatches = document.querySelectorAll('.list-option-swatch');
    
    allOptionSwatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        
        // 1. Display Update (Move border/selected class)
        const wrapper = this.closest('.list-option-wrapper');
        const siblings = wrapper.querySelectorAll('.list-option-swatch');
        siblings.forEach(s => s.classList.remove('is-selected'));
        this.classList.add('is-selected');
        
        // 2. Update Text Name Option
        const labelText = wrapper.querySelector('.selected-option-text');
        const selectedValue = this.getAttribute('data-value');
        if (labelText && selectedValue) {
          labelText.textContent = selectedValue;
        }
        
        const productContainer = this.closest('.collection__grid__item');
        if (!productContainer) return;

        // 3. MAIN IMAGE UPDATE (New Feature!)
        const newImageUrl = this.getAttribute('data-main-image');
        if (newImageUrl && newImageUrl.trim() !== '') {
          const mainImage = productContainer.querySelector('.list-main-image');
          if (mainImage) {
            // Delete Shopify's built-in srcset to allow the browser to load new src images
            mainImage.removeAttribute('srcset'); 
            mainImage.src = newImageUrl;
          }
        }

        // 4. Find the Right Variant ID Combination
        const variantDataNode = productContainer.querySelector('.list-variant-data');
        if (!variantDataNode) return;
        const variants = JSON.parse(variantDataNode.textContent);

        let selectedOptions = [];
        const allOptionWrappers = productContainer.querySelectorAll('.list-option-wrapper');
        
        allOptionWrappers.forEach(wrap => {
          const index = parseInt(wrap.getAttribute('data-option-index'));
          const selectedSwatch = wrap.querySelector('.list-option-swatch.is-selected');
          if (selectedSwatch) {
            selectedOptions[index] = selectedSwatch.getAttribute('data-value');
          }
        });

        const matchedVariant = variants.find(v => {
          return v.options.every((opt, i) => {
            if (selectedOptions[i] === undefined || selectedOptions[i] === null) return true;
            return opt === selectedOptions[i];
          });
        });

        // 5. Update the basket form with the new Variant ID
        if (matchedVariant) {
          const formInput = productContainer.querySelector('.selected-variant-input');
          if (formInput) {
            formInput.value = matchedVariant.id;
          }
          // 6. Sync BUY NOW link href so the chosen variant carries over to the product page
          const buyBtn = productContainer.querySelector('.list-build-btn');
          if (buyBtn) {
            const baseUrl = (buyBtn.getAttribute('href') || '').split('?')[0];
            buyBtn.setAttribute('href', baseUrl + '?variant=' + matchedVariant.id);
          }
        }
      });
    });
  });

  /* =======================================================
     SCRIPT SWITCH LAYOUT DESKTOP & HP SPECIAL LIST VIEW
  ======================================================= */
  document.addEventListener('DOMContentLoaded', function() {
    const listButtons = document.querySelectorAll('.list-switch-btn');
    const productGrid = document.getElementById('product-grid');

    if (listButtons.length > 0 && productGrid) {
      // INITIAL DEFAULT SET COLUMNS
      productGrid.setAttribute('data-custom-cols', '1');

      listButtons.forEach(button => {
        button.addEventListener('click', function() {
          // 1. Change the visually active status on the button
          listButtons.forEach(btn => btn.classList.remove('is-active'));
          this.classList.add('is-active');
          
          // 2. Take the column target (1 or 2)
          const targetCols = this.getAttribute('data-columns');
          
          // 3. Send the data-custom-cols attribute to the product container
          productGrid.setAttribute('data-custom-cols', targetCols);
        });
      });
    }
  });
// End of Function Collection list view

// Function contten slideshow
document.addEventListener('DOMContentLoaded', () => {
    const initSlideshow = (section) => {
      const slider = section.querySelector('.content-slideshow__slider');
      if (!slider) return;

      const track = slider.querySelector('.slider-track');
      const slides = slider.querySelectorAll('.slide');
      const dotsContainer = slider.querySelector('.slider-dots');
      
      if (slides.length <= 1) return;

      const autoplay = slider.dataset.autoplay === 'true';
      const speed = parseInt(slider.dataset.speed, 10) || 5000;
      let current = 0;
      let interval;

      dotsContainer.innerHTML = '';
      slides.forEach((_, i) => {
        const dot = document.createElement('div');
        dot.classList.add('slider-dot');
        if (i === 0) dot.classList.add('active');
        
        dot.addEventListener('click', () => {
          current = i;
          updateSlider();
          resetAutoplay();
        });
        
        dotsContainer.appendChild(dot);
      });

      const dots = dotsContainer.querySelectorAll('.slider-dot');

      const updateSlider = () => {
        track.style.transform = `translateX(-${current * 100}%)`;
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === current);
        });
      };

      const startAutoplay = () => {
        if (autoplay) {
          interval = setInterval(() => {
            current = (current + 1) % slides.length;
            updateSlider();
          }, speed);
        }
      };

      const resetAutoplay = () => {
        if (interval) clearInterval(interval);
        startAutoplay();
      };

      updateSlider();
      startAutoplay();
    };

    document.querySelectorAll('.content-slideshow').forEach(initSlideshow);

    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.querySelector('.content-slideshow')) {
        initSlideshow(e.target);
      }
    });
  });
// End of Function contten slideshow
